import {AzureLayer} from "@esWebAPI/es/map/layer/azure/AzureLayer";
import atlas, {Map, source } from "azure-maps-control";
import PolygonLayer = atlas.layer.PolygonLayer;
import {AzureImageSpriteManager} from "@esWebAPI/es/map/layer/AzureImageSpriteManager";
import {ExpressionFilterSpecification} from "@maplibre/maplibre-gl-style-spec";

export class AzureTerritorySelectionLayer implements AzureLayer {

    private readonly _map: Map;
    private readonly spriteManager: AzureImageSpriteManager;

    private _layer: PolygonLayer|undefined;

    constructor(map: Map, spriteManager: AzureImageSpriteManager) {
        this._map = map;
        this.spriteManager = spriteManager;
    }

    public async create(datasource: source.Source): Promise<void> {
        this._layer = new PolygonLayer(datasource.getId(), this.getLayerId(), {
            sourceLayer: datasource instanceof source.VectorTileSource ? "es" : undefined,
            fillPattern: "diagonal-lines-up-black",
            fillOpacity: 0.8,
            filter: ["!", true]
        });
        this._map.layers.add(this._layer)
        await this.spriteManager.createFromTemplate("diagonal-lines-up-black", "diagonal-lines-up", "rgba(0,0,0,0.6)", 'rgba(0,0,0,0)');
    }

    public setFilter(filter?: ExpressionFilterSpecification) {
        this._layer?.setOptions({ filter });
    }

    update(): Promise<void> {
        throw new Error("Method not implemented.");
    }

    remove(): void {
        if (this._layer && this._map.layers.getLayerById(this.getLayerId())) {
            this._map.layers.remove(this.getLayerId());
        }
    }

    hide(): void {
        throw new Error("Method not implemented.");
    }

    hideFeature(_featureId: number): void {
        throw new Error("Method not implemented.");
    }

    showFeatures(): void {
        throw new Error("Method not implemented.");
    }

    getLayerId(): string {
        return "territory-selection-layer";
    }


}